import React, { useEffect, useRef } from 'react';

import gsap from 'gsap';

// Props du composant PageTransition
interface PageTransitionProps {
    children: React.ReactNode;
}

// Composant pour gérer la transition d'une page à une autre avec animation
const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
    // 1. Créer une référence pour l'élément DOM
    const el = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!el.current) return;

        // 2. Définir l'état initial (depuis la gauche, invisible)
        gsap.set(el.current, { opacity: 0, x: -40 });

        const ctx = gsap.context(() => {
            const tl = gsap.timeline({});
            // 3. Animer vers l'état final (position normale, visible)
            tl.to(el.current, {
                opacity: 1,
                x: 0,
                duration: 1,
                ease: 'back.out(1.7)',
                stagger: 0.3,
            });
        }, el);

        return () => ctx.revert();
    }, []);

    return (
        <div
            ref={el}
            style={{
                width: '100%',
                height: '100%',
                position: 'relative',
            }}
        >
            {children}
        </div>
    );
};

export default PageTransition;
